import { render, staticRenderFns } from "./ModalCadastroCampanha.vue?vue&type=template&id=15a4ce7e&scoped=true&"
import script from "./ModalCadastroCampanha.vue?vue&type=script&lang=js&"
export * from "./ModalCadastroCampanha.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastroCampanha.vue?vue&type=style&index=0&id=15a4ce7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4ce7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
